import { CalendarDays, Compass } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useLanguage } from '../../context/LanguageContext'
import Button from '../ui/Button'

export default function ChoosingProgramCta() {
  const { t } = useTranslation()
  const { isRTL } = useLanguage()

  return (
    <div className="my-10 rounded-2xl border border-primary/15 bg-gradient-to-br from-primary/5 via-background to-accent/5 p-6 shadow-sm sm:p-8">
      <p className="mb-5 text-sm font-semibold uppercase tracking-widest text-accent">
        {t('pagesExtras.choosingProgramCta.label')}
      </p>
      <div className={`flex flex-col gap-3 sm:flex-row sm:flex-wrap ${isRTL ? 'sm:flex-row-reverse' : ''}`}>
        <Button to="/contact" variant="accent" size="lg" className="w-full sm:w-auto">
          <CalendarDays className="h-5 w-5 shrink-0" aria-hidden />
          {t('pagesExtras.bookVisit')}
        </Button>
        <Button to="/programs" variant="outlineDark" size="lg" className="w-full sm:w-auto">
          <Compass className="h-5 w-5 shrink-0" aria-hidden />
          {t('buttons.explorePrograms')}
        </Button>
      </div>
    </div>
  )
}
